import type { Network } from '../types'

const QUICKNODE_RPC_CONFIGS: Partial<Record<Network, (endpointName: string, apiKey: string) => string>> = {
  mainnet: (endpointName, apiKey) => `https://${endpointName}.quiknode.pro/${apiKey}`,
  arbitrum: (endpointName, apiKey) => `https://${endpointName}.arbitrum-mainnet.quiknode.pro/${apiKey}`,
  avalanche: (endpointName, apiKey) => `https://${endpointName}.avalanche-mainnet.quiknode.pro/${apiKey}/ext/bc/C/rpc`,
  base: (endpointName, apiKey) => `https://${endpointName}.base-mainnet.quiknode.pro/${apiKey}`,
  berachain: (endpointName, apiKey) => `https://${endpointName}.berachain-mainnet.quiknode.pro/${apiKey}`,
  bsc: (endpointName, apiKey) => `https://${endpointName}.bsc.quiknode.pro/${apiKey}`,
  celo: (endpointName, apiKey) => `https://${endpointName}.celo-mainnet.quiknode.pro/${apiKey}`,
  gnosis: (endpointName, apiKey) => `https://${endpointName}.xdai.quiknode.pro/${apiKey}`,
  ink: (endpointName, apiKey) => `https://${endpointName}.ink-mainnet.quiknode.pro/${apiKey}`,
  katana: (endpointName, apiKey) => `https://${endpointName}.katana-mainnet.quiknode.pro/${apiKey}`,
  linea: (endpointName, apiKey) => `https://${endpointName}.linea-mainnet.quiknode.pro/${apiKey}`,
  monad: (endpointName, apiKey) => `https://${endpointName}.monad-mainnet.quiknode.pro/${apiKey}`,
  optimism: (endpointName, apiKey) => `https://${endpointName}.optimism-mainnet.quiknode.pro/${apiKey}`,
  plasma: (endpointName, apiKey) => `https://${endpointName}.plasma-mainnet.quiknode.pro/${apiKey}`,
  polygon: (endpointName, apiKey) => `https://${endpointName}.matic.quiknode.pro/${apiKey}`,
  robinhood: (endpointName, apiKey) => `https://${endpointName}.robinhood-mainnet.quiknode.pro/${apiKey}`,
  unichain: (endpointName, apiKey) => `https://${endpointName}.unichain-mainnet.quiknode.pro/${apiKey}`,
  worldchain: (endpointName, apiKey) => `https://${endpointName}.worldchain-mainnet.quiknode.pro/${apiKey}`,
}

export function getQuickNodeRpcUrl(network: Network): string | undefined {
  const config = QUICKNODE_RPC_CONFIGS[network]
  if (!config) return undefined

  const endpointName = process.env.QUICKNODE_ENDPOINT_NAME
  if (!endpointName) return undefined

  const apiKey = process.env.QUICKNODE_API_KEY
  if (!apiKey) return undefined

  return config(endpointName, apiKey)
}
